import {ADMIN_LANG} from "../../settings";
import {Table} from "react-bootstrap";
import React, {useCallback, useMemo} from "react";
import {EventIcon} from "./Icons";
import {Eye} from "react-bootstrap-icons";
import {formatRelativeDate} from "./utils";
import {LogEvent} from "../../types/admin";
import {openModal} from "../../app/slices/modals/eventModal";
import {useAppDispatch} from "../../app/store";

type Props = {
    events: LogEvent[]
}
const EventTable = ({events}: Props) => {
    const dispatch = useAppDispatch();

    const handleOpenEventModal = useCallback((event_id: string) => {
        dispatch(openModal({event_id}));
    }, [dispatch]);

    const eventRows = useMemo(() => events.map((event) => (
        <tr key={event.event_id}>
            <td colSpan={2}>
                <span className='me-3'><EventIcon type={event.type}/></span>
                <span dangerouslySetInnerHTML={{__html: event.message}}></span>
            </td>
            <td>
                {formatRelativeDate(event.date)}
                {formatRelativeDate(event.date) !== ADMIN_LANG.just_now && (
                    <> {ADMIN_LANG.ago}</>
                )}
                {event.changes.length > 0 ?
                <span className='modal-link ms-3'
                      onClick={() => handleOpenEventModal(event.event_id)}><Eye/></span> : ''}
            </td>
        </tr>
    )), [events, handleOpenEventModal]);

    return (
        <div className='table-container'>
            <Table responsive hover striped>
                <tbody>
                {eventRows}
                </tbody>
            </Table>
        </div>
    )
}

export default EventTable;